<template>
  <div class="header-controls" id="header__controls">
    <b-modal centered hide-footer id="feedbackModal" title="Send Feedback">
      <FeedbackModal ref="refFeedbackModal" />
    </b-modal>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-7 col-md-8 col-8 left-side">
          <div class="form-inline" v-if="$router.currentRoute.name == 'globalAlert'">
            <b-button
              class="header-filter-btns"
              variant="theme"
              @click="$emit('createNewAlert')"
            >
              Add Alert
              <i class="fas text-primary fa-plus fa-fw"></i>
            </b-button>
          </div>
          <div :class="`form-inline ${$router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek' ? 'deliverableTemplate-filter-form' : ''}`" v-if="$router.currentRoute.name != 'permissionManager' && $router.currentRoute.name != 'globalAlert' && $router.currentRoute.name != 'userGlobalAlert'">
            <div class="input-group top-search">
              <input
                type="text"
                class="form-control"
                :class="$router.currentRoute.name == 'globalSearch' ? '' : 'media-calls-search'"
                v-model="searchQuery"
                v-debounce:500ms="setQuery"
                :debounce-events="['keyup']"
                :placeholder="querySearchPlaceHolder"
                @click="$refs.searchQuery.select()"
                @keypress.enter="triggerSearch"
                ref="searchQuery"
                id="search-query"
              />
              <div class="input-group-append cursor-pointer" @click="triggerSearch">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <!-- <b-button
              ref="filterBoxBtn"
              id="popover-button-event"
              class="ml-2 header-filter-btns"
              variant="theme"
              tabindex="0"
              href="#"
              v-if="$router.currentRoute.name != 'globalSearch'"
              @keydown.esc="$refs.popover.$emit('close')"
            >
              <span :class="{'wider-filter-only': $router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek'}">Filter</span>
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button> -->
            <b-popover
              triggers="click blur"
              boundary="window"
              placement="bottom"
              ref="popover"
              target="popover-button-event"
              custom-class="deliverableTemplate-filter"
            >
              <div class="d-flex flex-row">
                <div class="filter-item item__status">
                  <label v-html="getCalendarStatusLabel"></label>
                  <div v-if="!isMobile()" class="status-wrap">
                    <a
                      href="#"
                      @click="setStatusFilter(s)"
                      class="badge mr-2"
                      :style="{color: 'var(--wf-secondary)', backgroundColor: s.color}"
                      v-for="(s, index) in statuses"
                      :key="index"
                    >{{ s.name }}</a>
                  </div>
                  <div class="custom-field status-field">
                    <multiselect
                      v-if="isMobile()"
                      :searchable="true"
                      v-model="filterQuery.status"
                      label="name"
                      :options="statuses"
                      placeholder="Select status"
                      :show-labels="false"
                      :multiple="true"
                      :hide-selected="true"
                    >
                      <template slot="option" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
                        >{{ props.option.name }}</div>
                      </template>
                      <template slot="tag" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }"
                        >{{ props.option.name }}</div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__outlet" v-if="checkCalendarMode(['deliverableTemplates', 'tasks'])">
                    <div>
                      <label>Outlet</label>
                      <b-form-checkbox
                        v-if="isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noOutlet"
                        id="no-outlet"
                        name="no-outlet"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                      >No Outlet</b-form-checkbox>
                    </div>
                    <div class="outlet-wrap">
                      <multiselect
                        ref="outletFilter"
                        v-model="filterQuery.outlet"
                        track-by="id"
                        open-direction="bottom"
                        label="name"
                        :options="contacts"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :hide-selected="true"
                        :preserve-search="true"
                        :clear-on-select="false"
                        :internal-search="false"
                        :loading="isContactsLoading"
                        @select="filterQuery.noOutlet='not_accepted'"
                        @search-change="onWhoSearch"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                            <br />
                            <span class="option__small text-muted">{{ props.option.company_name }}</span>
                          </div>
                        </template>
                        <template slot="noOptions">Start typing to find contacts.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noOutlet"
                      id="no-outlet"
                      name="no-outlet"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''"
                    >No Outlet</b-form-checkbox>
                  </div>
                  <div class="filter-item item__coordinator">
                    <label>Assigned To</label>
                    <div class="coordinator-wrap">
                      <multiselect
                        ref="coordinatorFilter"
                        v-model="filterQuery.coordinator"
                        :options="allActiveUsers"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="filter-item item__deliverableTemplate__type" v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'mediaCallPage' && checkCalendarMode(['deliverableTemplates', 'tasks'])">
                    <label>DeliverableTemplate Type</label>
                    <div class="deliverableTemplate-type-wrap">
                      <multiselect
                        ref="deliverableTemplateFilter"
                        v-model="filterQuery.deliverableTemplate"
                        :options="deliverableTemplate"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__department">
                    <div>
                      <label>Department</label>
                      <b-form-checkbox
                        v-if="isMobile()"
                        class="float-right csm-checkbox"
                        v-model="filterQuery.noDepartment"
                        id="no-department"
                        name="no-department"
                        value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                      >No Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect
                        ref="departmentFilter"
                        v-model="filterQuery.department"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :options="allActiveDepartments"
                        :hide-selected="true"
                        :show-labels="false"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        @select="filterQuery.noDepartment = 'not_accepted'"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find departments.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox
                      v-if="!isMobile()"
                      class="mt-2 csm-checkbox"
                      v-model="filterQuery.noDepartment"
                      id="no-department"
                      name="no-department"
                      value="accepted"
                      unchecked-value="not_accepted"
                      @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''"
                    >No Department</b-form-checkbox>
                  </div>
                  <div class="filter-item item__tag" v-if="checkCalendarMode(['deliverableTemplates', 'tasks'])">
                    <label>Tag</label>
                    <div class="tag-wrap">
                      <multiselect
                        ref="tagFilter"
                        v-model="filterQuery.tag"
                        :options="tags"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="name"
                        track-by="id"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :loading="isTagsLoading"
                        :preserve-search="true"
                        @search-change="onTagSearch"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find tags.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="filter-item item__project" v-if="checkCalendarMode(['deliverableTemplates', 'tasks'])">
                    <label>Project</label>
                    <div class="project-wrap">
                      <multiselect
                        ref="projectFilter"
                        v-model="filterQuery.project"
                        :options="allProjects"
                        :show-labels="false"
                        :multiple="true"
                        open-direction="bottom"
                        label="title"
                        track-by="id"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span
                            class="multiselect__single"
                            v-if="values.length && !isOpen"
                          >{{ values.length }} options selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="filter-item item__date" :class="{'filter-item-no-border': $router.currentRoute.name == 'calendar'}">
                  <div class="due__created__dates">
                    <div>
                      <label>{{dueDateLabel}}</label>
                      <br />
                      <date-range-picker
                        ref="picker"
                        @update="onUpdateDueDate"
                        :autoApply="true"
                        :ranges="customDueDateRanges"
                        v-model="filterQuery.dateRange"
                      ></date-range-picker>
                    </div>
                    <!-- filter by task due date -->
                    <div v-if="$router.currentRoute.name == 'dashboard' || $router.currentRoute.name == 'myWeek'">
                      <label class="mt-2">Task Due Date</label>
                      <br />
                      <date-range-picker
                        ref="picker"
                        @update="onUpdateTaskDueDate"
                        :autoApply="true"
                        :ranges="customDueDateRanges"
                        v-model="filterQuery.taskDateRange"
                      ></date-range-picker>
                    </div>
                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCreated"
                        @update="onUpdateDateCreated"
                        :autoApply="true"
                        :ranges="customCreatedDateRanges"
                        v-model="filterQuery.dateCreatedRange"
                      ></date-range-picker>
                    </div>
                    <div v-if="checkCalendarMode(['deliverableTemplates', 'tasks'])">
                      <label class="mt-lg-2">Completed</label>
                      <br />
                      <date-range-picker
                        ref="pickerDateCompleted"
                        @update="onUpdateDateCompleted"
                        :autoApply="true"
                        :ranges="customCompletedDateRanges"
                        v-model="filterQuery.dateCompletedRange"
                      ></date-range-picker>
                    </div>
                  </div>
                </div>
                <div class="filter-item item__priority filter-item-no-border" v-if="checkCalendarMode(['deliverableTemplates', 'tasks'])">
                  <div class="priority__filter">
                    <label>Priority</label>
                    <br />
                    <div @click="setPriority" class="filter-rating">
                      <vue-star-rate
                        :rateRange="filterQuery.priorityFilter"
                        :maxIcon="5"
                        :iconHeight="17"
                        :iconWidth="17"
                        :hasCounter="false"
                        iconColor="var(--wf-primary)"
                        iconColorHover="var(--wf-primary)"
                        iconShape="circle"
                      ></vue-star-rate>
                    </div>
                  </div>

                  <div class="priority__sort">
                    <label class="mt-2">Sort by Priority</label>
                    <br>
                    <div
                      v-if="$router.currentRoute.name != 'globalSearch'"
                      class="btn-group add-new__global_search sorting main__filter"
                    >
                      <button
                        class="btn btn-theme header-filter-btns dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Sort
                        <i class="fas fa-sort text-primary float-right"></i>
                      </button>
                      <div class="dropdown-menu">
                        <a
                          class="dropdown-item"
                          @click="setSort('priorityDesc')"
                          href="#"
                        >Priority Decending</a>
                        <a class="dropdown-item" @click="setSort('priorityAsc')" href="#">Priority Ascending</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="item__reset">
                    <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i class="fas fa-undo"></i></b-button>
                    <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm" @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                  </div>
                </div>
              </div>
              <div
                class="d-none d-md-block mt-3 test1"
                v-show="isFilterActive()" :key="'filterKey'+reloadCounter"
              >
                <label>Click to remove filters :</label>
                <br />
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.query = null; searchQuery = ''"
                  :style="{cursor: 'pointer'}"
                >{{ filterQuery.query }}</span>
                <span
                  class="badge mr-2 mb-2"
                  @click="removeFilter(status)"
                  :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
                  v-for="status in filterQuery.status"
                >{{ status.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(outlet)"
                  :style="{cursor: 'pointer'}"
                  v-for="outlet in filterQuery.outlet"
                >{{ outlet.name }}</span>
                <span v-if="Array.isArray(filterQuery.deliverableTemplate)">
                  <span
                    class="badge badge-primary mr-2 mb-2"
                    @click="removeFilter(deliverableTemplate)"
                    :style="{cursor: 'pointer'}"
                    v-for="deliverableTemplate in filterQuery.deliverableTemplate"
                  >{{ deliverableTemplate.name }}</span>
                </span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('deliverableTemplate')"
                  :style="{cursor: 'pointer'}"
                  v-else-if="(typeof filterQuery.deliverableTemplate != 'undefined')"
                >{{ filterQuery.deliverableTemplate.name }}</span>
                <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
                <span
                  v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
                  class="badge mr-2 mb-2 bg-primary cursor-pointer"
                  style="color: var(--wf-secondary);"
                  @click="removeFilter('resetDeliverableTemplateSort')"
                >{{ filterQuery.sort == 'priorityDesc' ? 'Priority Descending' : 'Priority Ascending' }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(coordinator)"
                  :style="{cursor: 'pointer'}"
                  v-for="coordinator in filterQuery.coordinator"
                >{{ coordinator.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDate"
                >{{dueDateLabel}}: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByTaskDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByTaskDate"
                >Task Due Date: {{ filterQuery.taskDateRange.startDate | moment('MMM DD') }} - {{ filterQuery.taskDateRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.filterNoDueDate=false"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterNoDueDate == 1"
                >No {{dueDateLabel}}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.filterNoTaskDueDate=false"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterNoTaskDueDate == 1"
                >No Task Due Date</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCreated')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCreated"
                >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByDateCompleted')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByDateCompleted"
                >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>

                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(tag)"
                  :style="{cursor: 'pointer'}"
                  v-for="tag in filterQuery.tag"
                >{{ tag.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(department)"
                  :style="{cursor: 'pointer'}"
                  v-for="department in filterQuery.department"
                >{{ department.name }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter(project)"
                  :style="{cursor: 'pointer'}"
                  v-for="project in filterQuery.project"
                >{{ project.title }}</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noDepartment='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noDepartment == 'accepted'"
                >No Department</span>
                <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="filterQuery.noOutlet='not_accepted'"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.noOutlet == 'accepted'"
                >No Outlet</span>
              </div>
            </b-popover>

            <div class="ml-2 calendar-type-control" v-if="$router.currentRoute.name == 'calendar'">
              <label class="btn-theme date-filter-triggers">
                <b-form-radio
                  ref="deliverableTemplates"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="deliverableTemplates"
                  value="deliverableTemplates"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('deliverableTemplates')"
                >
                  DeliverableTemplates
                </b-form-radio>
              </label>
              <!-- <label class="btn-theme ml-2 date-filter-triggers">
                <b-form-radio
                  ref="tasks"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="tasks"
                  value="tasks"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('tasks')"
                >
                  Tasks
                </b-form-radio>
              </label> -->
              <label class="btn-theme ml-2 date-filter-triggers">
                <b-form-radio
                  ref="projects"
                  v-model="dataSetType"
                  class="csm-checkbox"
                  id="projects"
                  value="projects"
                  name="dataSetTypeTrigger"
                  @change="changeCalendarMode('projects')"
                >
                  Projects
                </b-form-radio>
              </label>
            </div>
            <div class="new-deliverableTemplates ml-2" v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar' && $router.currentRoute.name != 'mediaCallPage' && $router.currentRoute.name != 'socialMedia'">
              <div class="btn-group wider-filter-only">
                <button type="button" class="btn-theme btn-split-button header-filter-btns" data-toggle="dropdown" aria-expanded="false" v-if="hasMultipleDeliverableTemplate">New {{getBaseDeliverableTemplate()}}<i class="fas text-primary float-right fa-plus fa-fw"></i></button>
                <button type="button" class="btn-theme dropdown-toggle dropdown-toggle-split btn-split-button" data-toggle="dropdown" aria-expanded="false" v-if="hasMultipleDeliverableTemplate">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" v-for="(type,i) in newDeliverableTemplates" :key="i" @click.prevent="createDeliverableTemplateDropdownClick(type)">{{type.title}}</a>
                </div>
              </div>
              <div class="mobile-filter-only">
                <button type="button" v-if="hasMultipleDeliverableTemplate" class="btn btn-theme header-filter-btns dropdown-toggle" data-toggle="dropdown" aria-expanded="false">New <i class="fas text-primary float-right fa-plus fa-fw" style="margin-left: 10px"></i></button>
                <button type="button" v-else class="btn btn-theme header-filter-btns" @click="createNewDeliverableTemplateFromId()">New <i class="fas text-primary float-right fa-plus fa-fw" style="margin-left: 10px"></i></button>
                <div v-if="hasMultipleDeliverableTemplate" class="dropdown-menu">
                  <a class="dropdown-item" v-for="(type,i) in newDeliverableTemplates" :key="i" @click.prevent="createDeliverableTemplateDropdownClick(type)">{{type.title}}</a>
                </div>
              </div>
            </div>

            <div class="ml-2">
              <FeedbackBtn />
            </div>
          </div>
          <div
            class="mt-3 filter-badges"
            v-if="isFilterActive()"
          >
            <label class="remove-filter-text">Click to remove filters:</label>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.query = null; searchQuery = ''"
              :style="{cursor: 'pointer'}"
            >{{ filterQuery.query }}</span>
            <span
              v-if="$router.currentRoute.name != 'globalSearch'"
              class="badge mr-2 mb-2"
              @click="removeFilter(status)"
              :style="{cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color}"
              v-for="status in filterQuery.status"
            >{{ status.name }}</span>
            <span
              v-if="$router.currentRoute.name == 'globalSearch'"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartStatus')"
            >{{ filterQuery.status[0] }}</span>
            <span
              v-if="$router.currentRoute.name == 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartTagSort')"
            >{{ filterQuery.sort == 'usedDesc' ? 'Frequency Descending' : 'Frequency Ascending' }}</span>
            <span
                  v-if="filterQuery.priorityFilter > 0"
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')"
                  :style="{cursor: 'pointer'}"
                >Priority {{ filterQuery.priorityFilter }}</span>
            <span
              v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);"
              @click="removeFilter('resetDeliverableTemplateSort')"
            >{{ filterQuery.sort == 'priorityDesc' ? 'Priority Descending' : 'Priority Ascending' }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(outlet)"
              :style="{cursor: 'pointer'}"
              v-for="outlet in filterQuery.outlet"
            >{{ outlet.name }}</span>
            <span v-if="Array.isArray(filterQuery.deliverableTemplate)">
              <span
                class="badge badge-primary mr-2 mb-2"
                @click="removeFilter(deliverableTemplate)"
                :style="{cursor: 'pointer'}"
                v-for="deliverableTemplate in filterQuery.deliverableTemplate"
              >{{ deliverableTemplate.name }}</span>
            </span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('deliverableTemplate')"
              :style="{cursor: 'pointer'}"
              v-else-if="(typeof filterQuery.deliverableTemplate != 'undefined')"
            >{{ filterQuery.deliverableTemplate.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(coordinator)"
              :style="{cursor: 'pointer'}"
              v-for="coordinator in filterQuery.coordinator"
            >{{ coordinator.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDate')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDate"
            >{{dueDateLabel}}: {{ filterQuery.dateRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
            <span
                  class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('filterByTaskDate')"
                  :style="{cursor: 'pointer'}"
                  v-if="filterQuery.filterByTaskDate"
                >Task Due Date: {{ filterQuery.taskDateRange.startDate | moment('MMM DD') }} - {{ filterQuery.taskDateRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.filterNoDueDate=false"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterNoDueDate == 1"
            >No {{dueDateLabel}}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.filterNoTaskDueDate=false"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterNoTaskDueDate == 1"
            >No Task Due Date</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCreated')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCreated"
            >Created: {{ filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByDateCompleted')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByDateCompleted"
            >Completed: {{ filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('filterByPublishDate')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.filterByPublishDate"
            >Date to Post: {{ filterQuery.datePublishRange.startDate | moment('MMM DD') }} - {{ filterQuery.datePublishRange.endDate | moment('MMM DD') }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(tag)"
              :style="{cursor: 'pointer'}"
              v-for="tag in filterQuery.tag"
            >{{ tag.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(department)"
              :style="{cursor: 'pointer'}"
              v-for="department in filterQuery.department"
            >{{ department.name }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter(project)"
              :style="{cursor: 'pointer'}"
              v-for="project in filterQuery.project"
            >{{ project.title }}</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noDepartment='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noDepartment == 'accepted'"
            >No Department</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="filterQuery.noOutlet='not_accepted'"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.noOutlet == 'accepted'"
            >No Outlet</span>

            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('overdue')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.overdue"
            >overdue</span>
             <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('today')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.today"
            >today</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('thisWeek')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.thisWeek"
            >this week</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('nextWeek')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.nextWeek"
            >next week</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('upcoming')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.upcoming"
            >upcoming</span>
            <span
              class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('noDeadline')"
              :style="{cursor: 'pointer'}"
              v-if="filterQuery.weekFilterOptions.noDeadline"
            >no deadline</span>

          </div>
        </div>
        <div class="col-sm-5 col-md-4 col-4 text-right right-side">
          <div class="logo-user">
            <HeaderNotification />
            <LoggedInUser />
            <Logo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Logo from "../common/Logo";
import LoggedInUser from "../common/LoggedInUser";
import HeaderNotification from "../common/HeaderNotification";
import FeedbackBtn from "../common/FeedbackBtn";
import FeedbackModal from "../common/FeedbackModal";
import ViewTitleModal from "../common/ViewTitleModal";
import router from "../../routes";
import vueStarRate from "vue-js-star-rating";

export default {
  props: ["myWeek", "GSDataType", "namespace"],
  data() {
    return {
      dataSetType: 'deliverableTemplates',
      deliverableTemplate: [],
      reloadCounter:0,
      GSCreatedDatePopover: false,
      customDueDateRanges: {
        "No Due Date": [null, null],
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
        "Next week": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(7, "days").toDate(),
        ],
        "Next two weeks": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(14, "days").toDate(),
        ],
      },
      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      searchQuery: "",
      isContactsLoading: false,
      isTagsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      departments: [],
      showUserSelect: false,
      expandAll: !this.isMobile(),
      filterQuery: {
        sort: "",
        query: "",
        isCalendarUpdate: false,
        filterByDate: false,
        filterByTaskDate: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        taskDateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        datePublishRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        outlet: [],
        tag: [],
        department: [],
        coordinator: [],
        project: [],
        noDepartment: "not_accepted",
        noOutlet: "not_accepted",
        weekFilterOptions: {
            overdue: false,
            today: false,
            thisWeek: false,
            nextWeek: false,
            upcoming: false,
            noDeadline: false,
        }
      },
      calendarMode: 'deliverableTemplates',
    };
  },
  components: {
    Logo,
    vueStarRate,
    HeaderNotification,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    ViewTitleModal,
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  // deliverableTemplate (state, getters) {
  	  //   return getters['deliverableTemplate']
  	  // },
      newDeliverableTemplates (state, getters) {
        return getters[this.namespace + 'newDeliverableTemplates']
      },
  	  allCustomFields (state, getters) {
  	    return getters[this.namespace + 'allCustomFields']
  	  },
  	  allUsers (state, getters) {
  	    return getters[this.namespace + 'allUsers']
  	  },
  	  allActiveUsers (state, getters) {
  	    return getters[this.namespace + 'allActiveUsers']
  	  },
  	  allDepartments (state, getters) {
  	    return getters[this.namespace + 'allDepartments']
  	  },
  	  allActiveDepartments (state, getters) {
  	    return getters[this.namespace + 'allActiveDepartments']
  	  },
  	  allContacts (state, getters) {
  	    return getters[this.namespace + 'allContacts']
  	  },
  	  allActiveContacts (state, getters) {
  	    return getters[this.namespace + 'allActiveContacts']
  	  },
  	  allTags (state, getters) {
  	    return getters[this.namespace + 'allTags']
  	  },
  	  deliverableTemplateFilter (state, getters) {
  	    return getters[this.namespace + 'deliverableTemplateFilter']
  	  },
  	  myWeekDeliverableTemplateFilter (state, getters) {
  	    return getters[this.namespace + 'myWeekDeliverableTemplateFilter']
  	  },
  	  mediaCallFilter (state, getters) {
  	    return getters[this.namespace + 'mediaCallFilter']
  	  },
  	  calendarFilter (state, getters) {
  	    return getters[this.namespace + 'calendarFilter']
  	  },
  	  globalSearchFilter (state, getters) {
  	    return getters[this.namespace + 'globalSearchFilter']
  	  },
  	  initialContacts (state, getters) {
  	    return getters[this.namespace + 'initialContacts']
  	  },
  	  initialTags (state, getters) {
  	    return getters[this.namespace + 'initialTags']
  	  },
  	  initialDepartments (state, getters) {
  	    return getters[this.namespace + 'initialDepartments']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },
  	  GSRecentSearch (state, getters) {
  	    return getters[this.namespace + 'GSRecentSearch']
  	  },
  	  userViews (state, getters) {
  	    return getters[this.namespace + 'userViews']
  	  },
  	  allProjects (state, getters) {
  	    return getters[this.namespace + 'allProjects']
  	  },
  	  getSystemSetting (state, getters) {
  	    return getters[this.namespace + 'getSystemSetting']
  	  },
  	  currentPage (state, getters) {
  	    return getters[this.namespace + 'currentPage']
  	  },
  	}),

  	getCalendarStatusLabel() {
  		if (this.calendarMode == "projects") {
  			return "Project Status";
  		}
  		return "Task Status";
  	},

    querySearchPlaceHolder() {
      if(this.$router.currentRoute.name == 'globalSearch') {
        return 'Global search...'
      } else if(this.$router.currentRoute.name == 'calendar') {
        return 'Search...'
      } else {
        return 'Search '+this.deliverableTemplatePlaceholder+'...'
      }
    },
    deliverableTemplatePlaceholder() {
      if (!this.hasMultipleDeliverableTemplate) {
        return this.deliverableTemplate[0].title;
      }

      let currentType = this.filterQuery.deliverableTemplate;
      if(typeof currentType != 'undefined' && typeof currentType.title != 'undefined') {
        return currentType.title
      } else if (typeof currentType == 'object' && currentType.length == 1) {
        return currentType[0].title;
      } else {
        return 'DeliverableTemplates';
      }
    },
    statuses() {
      let statusField = undefined;
      if (this.calendarMode == 'deliverableTemplates' || this.calendarMode == 'tasks') {
        statusField = _.find(this.allCustomFields, { field_key: "status" });
      } else if (this.calendarMode == 'projects') {
        statusField = _.find(this.allCustomFields, { field_key: "project_status" });
      }
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    },
    checkPermissions() {
      switch (this.GSDataType) {
        case "tags":
          return (
            this.userAbilities.createTag || this.userAbilities.editMediaCall
          );
        case "contacts":
          return (
            this.userAbilities.createContact || this.userAbilities.editMediaCall
          );
        case "coordinators":
          return this.userAbilities.createUser;
        case "departments":
          return (
            this.userAbilities.createDepartment ||
            this.userAbilities.editMediaCall
          );
      }
    },
    tabType() {
      return typeof this.GSDataType != "undefined" ? this.GSDataType : "";
    },

    hasMultipleDeliverableTemplate() {
      // always has multiple.
        return true;
    },

    isCalendarView() {
      return this.$router.currentRoute.name == 'calendar';
    },
    dueDateLabel() {
      if (this.calendarMode == 'deliverableTemplates' || this.calendarMode == 'tasks') {
        return 'DeliverableTemplate Due Date';
      } else if (this.calendarMode == 'projects') {
        return 'Deadline';
      } else {
        return 'Due Date'
      }
    },
    // Hardcode
		presetViewsMyWeek() {
			return [
				{
					id: 'p1',
					createdTime: null,
					title: "Today",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p2',
					createdTime: null,
					title: "This Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().startOf('week').toISOString()}","endDate":"${this.$moment().endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p3',
					createdTime: null,
					title: "Next Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().add(1, 'week').startOf('week').toISOString()}","endDate":"${this.$moment().add(1, 'week').endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p4',
					createdTime: null,
					title: "No Deadline",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"filterNoTaskDueDate":true,"noDepartment":"not_accepted","noCoordinator":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p5',
					createdTime: null,
					title: "Overdue",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"","endDate":"${this.$moment().add(-1, 'day').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]
		},
		presetViewsDashboard() {
			const filterForMyWeek = this.presetViewsMyWeek;
			const filterForDashboard =
			[
				{
					id: 'p101',
					createdTime: null,
					title: "Open DeliverableTemplates",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCreatedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCompletedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"status":[{"name":"Pending Completion","color":"var(--wf-pending-completion)"},{"name":"Not Started","color":"var(--wf-not-started)"},{"name":"In Progress","color":"var(--wf-in-progress)"},{"name":"Awaiting Approval","color":"var(--wf-awaiting-approval)"}],"outlet":[],"deliverableTemplate":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":false,"filterNoDueDate":false,"noDepartment":"not_accepted","weekFilterOptions": { "overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]

			return filterForDashboard.concat(filterForMyWeek);
		},
  },
  mounted() {
    let self = this
    if (router.currentRoute.name == "calendar") {
      let dataSetType = 'deliverableTemplates';
      if (
        this.calendarFilter &&
        typeof this.calendarFilter.dataSetType != "undefined" &&
        this.calendarFilter.dataSetType != ""
      ) {
        dataSetType = this.calendarFilter.dataSetType;
      } else {
        // calendar filter dataSetType="" and isCalendarUpdate = true
        this.filterQuery.dataSetType = dataSetType;
        this.filterQuery.isCalendarUpdate = false;
      }
      this.dataSetType = dataSetType;
      this.calendarMode = dataSetType;
    }
  	if (this.allProjects) {
	    if(this.allProjects.length == 0) {
	      this.fetchAllProjects()
	    }
	  } else {
	     this.fetchAllProjects()
	   }
     if (self.allActiveUsers.length == 0) {
       self.fetchActiveUsers();
     }
     if (self.allActiveDepartments.length == 0) {
       self.fetchActiveDepartments();
     }
     
    // Changed this because create deliverableTemplate is a split button so we need an initial type
    this.initDeliverableTemplate()
    // hiding the header logo when scrolling in mobile
    if(this.isMobile() && this.$store.getters.isLoggedIn) {

      $('html').removeClass('is__safari');
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls").style.top = "0";
        } else {
          document.getElementById("header__controls").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }

    this.$root.$on('bv::popover::show', bvEventObj => {
      $('body').addClass('popover-shown');
    });
    this.$root.$on('bv::popover::hide', bvEventObj => {
      $('body').removeClass('popover-shown');
    });
    this.$root.$on('setSaveView', () => {
			this.loadView();
		});
		this.$root.$on('resetFilter', () => {
			this.resetFilter();
		});

    this.$root.$on('filterQueryUpdate', (eventObj) => {
      self.filterQuery.filterByPublishDate = eventObj.currentFilter.filterByPublishDate;
      self.filterQuery.datePublishRange = eventObj.currentFilter.datePublishRange;
      self.reloadCounter++;
    });

    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");
    if (router.currentRoute.name == "myWeek") {
      this.filterQuery = this.myWeekDeliverableTemplateFilter;
    } else if (router.currentRoute.name == "dashboard") {
    	if (this.deliverableTemplateFilter) {
    	  this.filterQuery = this.deliverableTemplateFilter;
    	}
    } else if (router.currentRoute.name == "mediaCallPage") {
    	if (this.mediaCallFilter) {
    	  this.filterQuery = this.mediaCallFilter;
    	}
    } else if (router.currentRoute.name == "calendar") {
      if (this.calendarFilter) {
      	this.filterQuery = this.calendarFilter;
      }
    } else if (router.currentRoute.name == "globalSearch") {
      this.globalSearchFilter.status = [];
      this.globalSearchFilter.sort = '';
      this.filterQuery = this.globalSearchFilter;
    }

    const startDate = new Date();
    startDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59

    if (!this.filterQuery.filterByDate) {
      this.filterQuery.dateRange = {
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (!this.filterQuery.filterByTaskDate) {
      this.filterQuery.taskDateRange = {
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (!this.filterQuery.filterByDateCompleted) {
      this.filterQuery.dateCompletedRange = {
        startDate: startDate,
        endDate: endDate,
      };
    }
    if (!this.filterQuery.filterByPublishDate) {
      this.filterQuery.datePublishRange = {
        startDate: startDate,
        endDate: endDate,
      };
    }

    // reset parameters just in case.
    this.filterQuery.parentDeliverableTemplateId = 0;
    this.filterQuery.listByDate = false;
  },
  methods: {
  	...mapActions({
  	  // getDeliverableTemplate (dispatch, payload) {
  	  //   return dispatch('getDeliverableTemplate', payload)
  	  // },
  	  getCalendarData (dispatch, payload) {
  	    return dispatch(this.namespace + 'getCalendarData', payload)
  	  },
  	  fetchAllProjects (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchAllProjects', payload)
  	  },
  	  filterNewDeliverableTemplatesBasedOnSettings (dispatch, payload) {
  	    return dispatch(this.namespace + 'filterNewDeliverableTemplatesBasedOnSettings', payload)
  	  },
  	  fetchActiveUsers(dispatch, payload) {
  	    return dispatch('fetchActiveUsers', payload)
  	  },
  	  fetchActiveDepartments (dispatch, payload) {
  	    return dispatch('fetchActiveDepartments', payload)
  	  },
  	}),
  	...mapMutations({
  	  setDataLoading (commit, payload) {
  	    return commit(this.namespace + 'setDataLoading', payload)
  	  },
  	}),
    isFilterActive() {
      if (router.currentRoute.name == "myWeek") {
        return (
             this.filterQuery.noDepartment == 'accepted'
          || this.filterQuery.noOutlet == 'accepted'
          || this.filterQuery.filterNoDueDate          
          || this.filterQuery.filterNoTaskDueDate
          || this.filterQuery.query
          || this.filterQuery.status.length
          || this.filterQuery.filterByDate          
          || this.filterQuery.filterByTaskDate
          || this.filterQuery.filterByDateCreated
          || this.filterQuery.filterByDateCompleted
          || this.filterQuery.filterByPublishDate          
          || this.filterQuery.coordinator.length
          || this.filterQuery.outlet.length
          || (
              (Array.isArray(this.filterQuery.deliverableTemplate) && this.filterQuery.deliverableTemplate.length)
              || (!Array.isArray(this.filterQuery.deliverableTemplate) && this.filterQuery.deliverableTemplate)
            )
          || this.filterQuery.tag.length          
          || this.filterQuery.department.length
          || this.filterQuery.sort
          || this.filterQuery.priorityFilter > 0
          || this.filterQuery.project.length          
          || this.filterQuery.weekFilterOptions.overdue
          || this.filterQuery.weekFilterOptions.today
          || this.filterQuery.weekFilterOptions.thisWeek
          || this.filterQuery.weekFilterOptions.nextWeek          
          || this.filterQuery.weekFilterOptions.upcoming
          || this.filterQuery.weekFilterOptions.noDeadline
           )
      } else{
        return (
             this.filterQuery.noDepartment == 'accepted'
          || this.filterQuery.noOutlet == 'accepted'
          || this.filterQuery.filterNoDueDate        
          || this.filterQuery.filterNoTaskDueDate
          || this.filterQuery.query
          || this.filterQuery.status.length
          || this.filterQuery.filterByDate        
          || this.filterQuery.filterByTaskDate
          || this.filterQuery.filterByDateCreated
          || this.filterQuery.filterByDateCompleted
          || this.filterQuery.filterByPublishDate        
          || this.filterQuery.coordinator.length
          || this.filterQuery.outlet.length
          || this.filterQuery.tag.length        
          || this.filterQuery.department.length
          || this.filterQuery.sort
          || this.filterQuery.priorityFilter > 0
          || this.filterQuery.project.length
        )
      }
    },
    createDeliverableTemplate(deliverableTemplate) {
      this.$store.dispatch(this.namespace + "createDeliverableTemplate", { deliverableTemplate });
    },
    toggleStatusView() {
      if(this.isMobile()) {
        if(this.expandAll) {
          $('.deliverableTemplate-status-overview').hide();
          $('.deliverableTemplate-dates').css('padding-top', 0);
        } else {
          $('.deliverableTemplate-status-overview').show();
          $('.deliverableTemplate-dates').css('padding-top', '15px');
        }
      }
    },
    getBaseDeliverableTemplate() {
      if (!this.deliverableTemplate || this.deliverableTemplate.length == 0) {
        return "Deliverable Template";
      } else {
        return this.deliverableTemplate.name;
      }
    },
    setPriority() {
      let priority = $('.filter-rating .vue-star-rate ul.list li.active').length;
      this.filterQuery.priorityFilter = priority;
      this.filterQuery.isCalendarUpdate = false;
    },
    removeView(viewId) {
      this.$store.dispatch(this.namespace + 'removeView', viewId);
    },
    loadView() {
      if(this.$router.currentRoute.name == 'dashboard') {
        this.filterQuery = this.deliverableTemplateFilter;
      } else if(this.$router.currentRoute.name == 'myWeek') {
        this.filterQuery = this.myWeekDeliverableTemplateFilter;
      } else if(this.$router.currentRoute.name == 'mediaCallPage') {
        this.filterQuery = this.mediaCallFilter;
      }
    },
    saveView() {
      this.$bvModal.show("viewTitleModal");
    },
    setSort(sortType) {
      this.filterQuery["sort"] = sortType;
      this.filterQuery.isCalendarUpdate = false;
    },
    setQuery() {
      this.filterQuery.isCalendarUpdate = false;
      this.filterQuery.query = this.searchQuery;
      if(this.$router.currentRoute.name == 'globalSearch') {
        let searchQuery = this.searchQuery;
        let activeTab = this.GSDataType;
        this.$store.commit(this.namespace + "setRecentSearch", { searchQuery, activeTab });
      }
    },
    onUpdateDueDate() {
      this.filterQuery.filterByDate = true;
      this.filterQuery.filterNoDueDate = false;
      this.focusFilterBtn();
    },
    onUpdateTaskDueDate() {
      this.filterQuery.filterByTaskDate = true;
      this.filterQuery.filterNoTaskDueDate = false;
      this.focusFilterBtn();
    },
    onUpdateDateCreated() {
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    onUpdateDateCompleted() {
      this.filterQuery.filterByDateCompleted = true;
      this.focusFilterBtn();
    },

    onWhoSearch(input) {
      if (input != "" || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if (typeof window.LIT !== "undefined") {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input)
              )
              .then((resp) => {
                this.isContactsLoading = false;
                this.contacts = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]["name"] =
                    resp.data[x]["first_name"] +
                    " " +
                    resp.data[x]["last_name"];
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", {
                  contacts: this.contacts,
                });
                resolve(this.contacts);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts;
      }
    },
    onTagSearch(input) {
      if (input != "" || this.initialTags.length == 0) {
        this.isTagsLoading = true;
        if (typeof window.LIT1 !== "undefined") {
          clearTimeout(window.LIT1);
        }
        window.LIT1 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
              .then((resp) => {
                this.isTagsLoading = false;
                this.tags = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.tags.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", { tags: this.tags });
                resolve(this.tags);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.tags = this.initialTags;
      }
    },
    onDepartmentSearchClose(input) {

    },
    onDepartmentSearch(input) {
      if (input != "" || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if (typeof window.LIT2 !== "undefined") {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL +
                  "departments?q=" +
                  encodeURI(input)
              )
              .then((resp) => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit(this.namespace + "setInitialData", {
                  departments: this.departments,
                });
                resolve(this.departments);
              })
              .catch((error) => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.initialDepartments;
      }
    },
    resetFilter() {
      this.filterQuery.isCalendarUpdate = false;
      this.$root.$emit('resetView');
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.filterNoTaskDueDate = false;
      this.filterQuery.noDepartment = "not_accepted";
      this.filterQuery.noOutlet = "not_accepted";
      this.filterQuery.query = null;
      this.searchQuery = "";
      this.filterQuery.priorityFilter = 0;
      $('.filter-rating .vue-star-rate ul li').each(function() {
        $(this).removeClass('active');
      })
      this.filterQuery.filterByDate = false;
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.filterByTaskDate = false;
      this.filterQuery.taskDateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByDateCompleted = false;
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByPublishDate = false;
      this.filterQuery.datePublishRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.status = [];
      this.filterQuery.outlet = [];
      this.filterQuery.deliverableTemplate = [];
      this.filterQuery.tag = [];
      this.filterQuery.sort = '';
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
      this.filterQuery.project = [];
    },
    outside() {
      this.showUserSelect = false;
    },
    createDeliverableTemplateDropdownClick(type) {

      this.deliverableTemplate = type;
      this.createNewDeliverableTemplateFromId();
    },
    createNewDeliverableTemplateFromId() {
      console.log("this.deliverableTemplate",this.deliverableTemplate);
      let type = this.deliverableTemplate.id;
      let that = this;
      // if (this.deliverableTemplate.slug) {
      // 	type = this.deliverableTemplate.slug;
      // }

      this.$store.dispatch(this.namespace + "createNewDeliverableTemplateFromId", type).then((response) => {
        const storeName = that.namespace || 'deliverableTemplates';
        const namespaceState = that.$store.state[storeName];
        const deliverableTemplateId = response?.data?.deliverableTemplateDetail?.id || namespaceState?.deliverableTemplateDetail?.id;
        
        if (deliverableTemplateId) {
          that.$router.push({
            name: 'deliverableTemplateNew',
            params: {
              deliverableTemplateId: deliverableTemplateId
            }
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error(err);
            }
          });
        }
        that.$store.dispatch(that.namespace + "fetchDeliverableTemplateCount");
        that.$store.dispatch(that.namespace + "fetchDeliverableTemplates");
      });
    },
    setStatusFilter(status) {
      this.filterQuery.isCalendarUpdate = false;
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    removeFilter(data) {
      this.filterQuery.isCalendarUpdate = false;
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartStatus"
          ) {
            this.filterQuery.status = [];
          }
          if(data == 'resetPriorityFilter') {
           this.filterQuery.priorityFilter = 0;
            $('.filter-rating .vue-star-rate ul li').each(function() {
              $(this).removeClass('active');
            });
          }
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartTagSort"
          ) {
            this.filterQuery.sort = "";
          }
          if (
            this.$router.currentRoute.name != "globalSearch" &&
            data == "resetDeliverableTemplateSort"
          ) {
            this.filterQuery.sort = "";
          }
          if(data == 'deliverableTemplate') {
            this.filterQuery.deliverableTemplate = [];
          }

          const startDate = new Date();
          startDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
          const endDate = new Date();
          endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59
          if (data == "filterByDate") {
            this.filterQuery.filterByDate = false;
            this.filterQuery.dateRange.startDate = startDate;
            this.filterQuery.dateRange.endDate = endDate;
          }
          if (data == "filterByTaskDate") {
            this.filterQuery.filterByTaskDate = false;
            this.filterQuery.taskDateRange.startDate = startDate;
            this.filterQuery.taskDateRange.endDate = endDate;
          }
          if (data == "filterByDateCreated") {
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = startDate;
            this.filterQuery.dateCreatedRange.endDate = endDate;
          }
          if (data == "filterByDateCompleted") {
            this.filterQuery.filterByDateCompleted = false;
            this.filterQuery.dateCompletedRange.startDate = startDate;
            this.filterQuery.dateCompletedRange.endDate = endDate;
          }
          if (data == "filterByPublishDate") {
            this.filterQuery.filterByPublishDate = false;
            this.filterQuery.datePublishRange.startDate = startDate;
            this.filterQuery.datePublishRange.endDate = endDate;
          }

          if (data == "overdue") {
            this.filterQuery.weekFilterOptions.overdue = false;
          }
           if (data == "today") {
            this.filterQuery.weekFilterOptions.today = false;
          }
           if (data == "thisWeek") {
            this.filterQuery.weekFilterOptions.thisWeek = false;
          }
           if (data == "nextWeek") {
            this.filterQuery.weekFilterOptions.nextWeek = false;
          }
           if (data == "upcoming") {
            this.filterQuery.weekFilterOptions.upcoming = false;
          }
           if (data == "noDeadline") {
            this.filterQuery.weekFilterOptions.noDeadline = false;
          }

        } else {
        	if (typeof this.filterQuery.deliverableTemplate != "undefined") {
	          this.filterQuery.deliverableTemplate = this.filterQuery.deliverableTemplate.filter((s) => {
	            return s.name != data.name;
	          });
	        }

	        if (typeof this.filterQuery.status != "undefined") {
	          this.filterQuery.status = this.filterQuery.status.filter((s) => {
	            return s.name != data.name;
	          });
	        }

	        if (typeof this.filterQuery.coordinator != "undefined") {
	          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
	            (s) => {
	              return s.name != data.name;
	            }
	          );
	        }
	        if (typeof this.filterQuery.outlet != "undefined") {
	          this.filterQuery.outlet = this.filterQuery.outlet.filter((s) => {
	            return s.name != data.name;
	          });
	        }

	        if (typeof this.filterQuery.tag != "undefined") {
	          this.filterQuery.tag = this.filterQuery.tag.filter((s) => {
	            return s.name != data.name;
	          });
	        }

	        if (typeof this.filterQuery.department != "undefined") {
	          this.filterQuery.department = this.filterQuery.department.filter(
	            (s) => {
	              return s.name != data.name;
	            }
	          );
	         }

          if (typeof this.filterQuery.project != "undefined") {
            this.filterQuery.project = this.filterQuery.project.filter(
              (s) => {
                return s.id != data.id;
              }
            );
          }
        }
      } else {
        // TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    triggerSearch() {
      if (this.$refs.searchQuery.value != "") {
        if (this.$router.currentRoute.name == "globalSearch") {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "globalSearch").then(() => {
            this.setDataLoading(false);
          });
        } else {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "fetchDeliverableTemplates").then(() => {
            this.setDataLoading(false);
          });
        }
      }
    },
    focusFilterBtn() {
      if (typeof this.$refs.filterBoxBtn != "undefined") {
        this.$refs.filterBoxBtn.focus();
      } else if (typeof this.$refs.GSCreatedDate != "undefined") {
        this.GSCreatedDatePopover = false;
      }
    },

    async initDeliverableTemplate() {
      // await this.getDeliverableTemplate();
      await this.filterNewDeliverableTemplatesBasedOnSettings();
      this.deliverableTemplate = this.deliverableTemplate[0];

    },

    changeCalendarMode(mode) {
      this.calendarMode = mode;
    },
    checkCalendarMode(modes) {
      if (!this.isCalendarView) {
        return true;
      } else {
        return modes.includes(this.calendarMode);
      }
    }
  },
  watch: {
    filterQuery: {
      handler: async function (val, oldVal) {
        this.$root.$emit('showUpdateViewText', {
          currentFilter: val,
          isFilterActive: this.isFilterActive()
        });
        this.filterQuery["myWeek"] = this.myWeek;
        if (
          this.filterQuery.filterByDate &&
          this.filterQuery.dateRange.startDate == null
        ) {
          this.filterQuery.filterByDate = false;
          this.filterQuery.dateRange = {
            startDate: new Date(),
            endDate: new Date(),
          };
          this.filterQuery.filterNoDueDate = true;
        }
        if (
          this.filterQuery.filterByTaskDate &&
          this.filterQuery.taskDateRange.startDate == null
        ) {
          this.filterQuery.filterByTaskDate = false;
          this.filterQuery.taskDateRange = {
            startDate: new Date(),
            endDate: new Date(),
          };
          this.filterQuery.filterNoTaskDueDate = true;
        }
        if (this.filterQuery.filterNoDueDate) {
          this.filterQuery.filterByDate = false;
        }
         if (this.filterQuery.filterNoTaskDueDate) {
          this.filterQuery.filterByTaskDate = false;
        }
        this.$store.commit(this.namespace + "setDeliverableTemplateFilter", this.filterQuery);
        if (router.currentRoute.name == "globalSearch") {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "globalSearch").then(() => {
            this.setDataLoading(false);
          });
        } if (router.currentRoute.name == "calendar") {
          if (this.filterQuery.isCalendarUpdate == false) {
            this.$root.$emit('calendarHeaderFilterUpdated');
          }
        } else if (router.currentRoute.name == "socialMediaSchedule") {
          this.setDataLoading(true);
          this.$store.dispatch(this.namespace + "fetchCalendarDeliverableTemplates").then(() => {
            this.setDataLoading(false);
          });
        } else {
          this.setDataLoading(true);
          await this.$store.dispatch(this.namespace + "fetchDeliverableTemplateCount");
          this.$store.dispatch(this.namespace + "fetchDeliverableTemplates").then(() => {
            this.setDataLoading(false);
          });
        }
        if (
          !this.filterQuery.query &&
          !this.filterQuery.filterByDate &&
          !this.filterQuery.filterByTaskDate &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.filterByDateCompleted &&
          !this.filterQuery.filterByPublishDate &&
          !this.filterQuery.status.length &&
          !this.filterQuery.coordinator.length &&
          !this.filterQuery.tag.length &&
          !this.filterQuery.department.length &&
          !this.filterQuery.project.length &&
          !this.filterQuery.outlet.length &&
          ((Array.isArray(this.filterQuery.deliverableTemplate) && !this.filterQuery.deliverableTemplate.length) || (!Array.isArray(this.filterQuery.deliverableTemplate) && !this.filterQuery.deliverableTemplate)) &&
          this.filterQuery.noDepartment != "accepted" &&
          this.filterQuery.noOutlet != "accepted" &&
          !this.filterQuery.filterNoDueDate &&
          !this.filterQuery.filterNoTaskDueDate &&
          !this.filterQuery.sort &&
          this.filterQuery.priorityFilter == 0
        ) {
          $(".deliverableTemplate-listing").removeClass("hasFilter");
          $(".global-search-data-wrapper").removeClass("hasFilter");
        } else {
          $(".deliverableTemplate-listing").addClass("hasFilter");
          $(".global-search-data-wrapper").addClass("hasFilter");
        }
      },
      deep: true,
    },
    expandAll: {
      handler: function (val, oldVal) {
        this.$emit("collapseToggleUpdated", val);
      },
    },
    calendarMode: {
      handler: function (val, oldVal) {
        if (this.filterQuery.dataSetType != val) {
          this.filterQuery.dataSetType = val;
          this.filterQuery.isCalendarUpdate = false;
          if (val == 'projects') {
            // Outlet
            this.filterQuery.outlet.forEach(outlet => {
              this.removeFilter(outlet);
            });
            this.filterQuery.noOutlet = 'not_accepted';

            // DeliverableTemplate Type
            this.filterQuery.deliverableTemplate.forEach(type => {
              this.removeFilter(type);
            });

            // Tag
            this.filterQuery.tag.forEach(tag => {
              this.removeFilter(tag);
            });

            // Project
            this.filterQuery.project.forEach(project => {
              this.removeFilter(project);
            });

            // Priority
            this.removeFilter('resetPriorityFilter');
            this.removeFilter('resetDeliverableTemplateSort');

            // Status
            this.filterQuery.status.forEach(status => {
              let isValidStatus = false;
              if (this.statuses) {
                this.statuses.forEach(ps => {
                  if (status.name == ps.name && status.color == ps.color) isValidStatus = true;
                });
              }

              if (!isValidStatus) {
                this.removeFilter(status);
              }
            });

            // Completed Date
            this.removeFilter('filterByDateCompleted');

          }
        }
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.multiselect__option:hover .text-muted {
  color: var(--darken-primary-bg-contrast-text-color) !important;
}
</style>
